export const TruncatedTextField = ({ record, source }) => {
    let str = record[source].replace(/(<([^>]+)>)/ig, '');

    return record ? (
        <span>{str.length > 30 ? str.slice(0, 30) + "..." : str.padEnd(30)}</span>
    ) : null;

};
